export default __webpack_public_path__ + "static/media/shift-report.3990aced.png";